import { useCallback } from 'react';
import { ReactionType } from '../../types';
import { REACTIONS_LIST } from '../../consts';
import { Wrapper, ScrollableList, ReactionButton } from './view';

interface ReactionsPanelProps {
    onReactionSelect: (type: ReactionType) => void;
}

interface ReactionButtonProps {
    reaction: ReactionType;
    onClick: (reaction: ReactionType) => void;
}

const ReactionButtonComponent = ({ reaction, onClick }: ReactionButtonProps) => {
    const handleClick = useCallback(() => {
        onClick(reaction);
    }, [reaction, onClick]);

    return (
        <ReactionButton onClick={handleClick} aria-label={`Send ${reaction} reaction`}>
            {reaction}
        </ReactionButton>
    );
};

export const ReactionsPanel = ({ onReactionSelect }: ReactionsPanelProps) => {
    return (
        <Wrapper>
            <ScrollableList>
                {REACTIONS_LIST.map((reaction) => (
                    <ReactionButtonComponent key={reaction} reaction={reaction} onClick={onReactionSelect} />
                ))}
            </ScrollableList>
        </Wrapper>
    );
};
